import { render, staticRenderFns } from "./mainContract.vue?vue&type=template&id=96427be2&scoped=true"
import script from "./mainContract.vue?vue&type=script&lang=js"
export * from "./mainContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96427be2",
  null
  
)

export default component.exports